/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import {Box} from '@mui/material';
import React from 'react';
import ContractsTable from './ContractsTable';
import {Route, Switch} from 'react-router';
import {useRouteMatch} from 'react-router-dom';
import ContractsForm from "./ContractsForm";

const Contracts = () => {
  const { path } = useRouteMatch();
  return (
    <Box display="flex" flexDirection="column" height={'100%'} gap={'8px'}>
      <Switch>
        <Route path={path} exact>
          <ContractsTable />
        </Route>
        <Route path={`${path}/new`}><ContractsForm/></Route>
        <Route path={`${path}/edit/:uuid`}><ContractsForm/></Route>
      </Switch>
    </Box>
  );
};

export default Contracts;
